import { render, staticRenderFns } from "./createCommission.vue?vue&type=template&id=321d69e8&scoped=true"
import script from "./createCommission.vue?vue&type=script&lang=js"
export * from "./createCommission.vue?vue&type=script&lang=js"
import style0 from "./createCommission.vue?vue&type=style&index=0&id=321d69e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321d69e8",
  null
  
)

export default component.exports